import { css } from '@emotion/react'

export const saveButtonWrapper = css`
  display: flex;
  justify-content: flex-end;

  margin: 24px 0;
  padding-bottom: 24px;
  width: 100%;
`

export const saveButton = css`
  width: fit-content;
`
